<template>
  <nav class="nav__container">
    <div class="nav__container--desktop">
      <ul class="nav-items--container">
        <li class="nav-item"><router-link to="/" exact>STRONA GŁÓWNA</router-link></li>
        <li class="nav-item"><router-link to="/o-firmie" exact>O FIRMIE</router-link></li>
        <li class="nav-item"><router-link to="/oferta" exact>OFERTA</router-link></li>
        <li class="nav-item"><router-link to="/kontakt" exact>KONTAKT</router-link></li>
        <li class="nav-item"><router-link to="/kariera" exact>KARIERA</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
